import type {ListExpedientsSearchInput} from "./list-expedients.schema";
import {listExpedients} from "@project/sdk/sales";
import {ListExpedientsResponse} from "@project/sdk/sales/zod";
import {queryOptions} from "@tanstack/react-query";
import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {expedientKeys} from "../../../expedient-keys";
import {listExpedientsSearchSchema} from "./list-expedients.schema";

export function listExpedientsQueryOptions(rawInput: ListExpedientsSearchInput) {
  const params = listExpedientsSearchSchema.parse(rawInput);
  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: expedientKeys.list(params),
    queryFn: async ({signal}) =>
      ListExpedientsResponse.parse(await listExpedients(params, {signal})),
  });
}
